(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ba-slider"]) return;
  try {
    
  const baSlider = () => {
    new Swiper('.ba_slider__swiper', {
      slidesPerView: 1.3,
      spaceBetween: 15,
      centerInsufficientSlides: true,
      scrollbar: {
        el: ".ba_slider__swiper .swiper-scrollbar",
        freeMode: true,
        draggable: true,
        hide: false
      },
      mousewheel: {
        forceToAxis: true,
      },
      breakpoints: {
        768: {
          slidesPerView: "auto",
        },
      },
    })
  }
  document.addEventListener('DOMContentLoaded', baSlider)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brands-info-v2"] && !Shopify.designMode) return;
  try {
    
  const brandsInfoSlider = () => {
    new Swiper('.brands-info__swiper', {
      spaceBetween: 10,
      slidesPerView: 1.1,
      loop: true,
      freeMode: true,
      mousewheel: {
        forceToAxis: true,
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
     },
     breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 2,
        },
        911: {
          slidesPerView: 4,
          spaceBetween: 0,
        }
      },
    })
  }

  document.addEventListener('DOMContentLoaded', () => {
    brandsInfoSlider();
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscription-banner"] && !Shopify.designMode) return;
  try {
    
  const setSubscription = () => {
    const link = "/products/slimdown-detox-tea-tt-sub"
    const container = document.querySelector(".product_section")
    const elementToGo = container?.querySelector('.product_swatch__bundles')
    const label = container?.querySelector("label[for='subscription']")
    const topSpace = 70
    
    if (label) {
      label.click()

      if (elementToGo) {
        const elementToGoPosition = elementToGo.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
          top: elementToGoPosition - topSpace,
          behavior: 'smooth'
        });
      }
    } else {
      window.location.href = link
    }
  }

  window.setSubscription = setSubscription;

  document.addEventListener("DOMContentLoaded", function() {
    new Swiper(".sub-banner__items", {
      freeMode: false,
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 20
        },
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      mousewheel: {
        forceToAxis: true,
      },
      scrollbar: {
        el: ".sub-banner__items .swiper-scrollbar",
        freeMode: true,
        draggable: true,
        hide: false
      },
      spaceBetween: 6,
      slidesPerView: 2.2,
      watchOverflow: true,
      centerInsufficientSlides: true,
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-it-works"] && !Shopify.designMode) return;
  try {
    
  const brandsInfoSlider = () => {
    new Swiper('.why-it-works-content-info-items', {
      spaceBetween: 10,
      slidesPerView: 1.2,
      loop: true,
      freeMode: false,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
     },
     breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 10,
        }
      },
    })
  }

  document.addEventListener('DOMContentLoaded', () => {
    brandsInfoSlider();
  })

  } catch(e) { console.error(e); }
})();
})();
